<template>
      <v-col>
          <v-card :loading="childLoadStatus===1">
            <v-toolbar dense flat>
              <v-btn @click="$router.go(-1)" small color="primary">
                <v-icon>mdi-arrow-left</v-icon>
                Powrót do listy
              </v-btn>
              <v-spacer></v-spacer>

              <v-dialog v-model="dialogSettlements">
                <template v-slot:activator="{ on }">
                  <v-btn @click="loadChildSettlements" v-on="on" small color="primary" class="mr-5">Rozliczenia</v-btn>
                </template>
                <v-card class="pl-1 pr-1">
                  <v-data-table
                    :headers="headersSettlements"
                    :items="tableChildSettlements"
                    class="elevation-0"
                    dense
                    hide-default-footer
                    disable-pagination
                    disable-sort
                    :loading="childSettlementsLoadStatus == 1"
                  >
                    <template v-slot:top>
                      <v-toolbar flat color="white">
                        <v-toolbar-title>Rozliczenia - {{ childItem.name }} {{ childItem.surname }}</v-toolbar-title>
                    
                        <v-spacer></v-spacer>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              size="28"
                              class="mr-4"
                              :disabled="tableChildSettlements.length==0"
                              @click="downloadSettlementsFile"
                            >
                              mdi-file-excel
                            </v-icon>
                          </template>
                          <span>Pobierz jako Excel</span>
                        </v-tooltip>
                        <v-menu
                                      v-model="dateSettlementsFromMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="settlementsDateFrom"
                                          label="Od"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          class="choose_date mt-6 mr-5"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker type="month" first-day-of-week="1" no-title v-model="settlementsDateFrom" @input="dateSettlementsFromMenu = false"></v-date-picker>
                      </v-menu>
                      <v-menu
                                      v-model="dateSettlementsToMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="settlementsDateTo"
                                          label="Do"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          class="choose_date mt-6 mr-5"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker type="month" first-day-of-week="1" no-title v-model="settlementsDateTo" @input="dateSettlementsToMenu = false"></v-date-picker>
                      </v-menu>              

                        <v-btn  @click="dialogSettlements = false" outlined class="mb-2 mt-2"  color="primary">
                          <v-icon>mdi-close-thick</v-icon>
                        </v-btn>
                        
                      </v-toolbar>
                    </template>
                    <template v-slot:item.month="{ item }">
                      {{ monthName(item.month) }}
                    </template>
                    <template  v-slot:item.amount="{ item }">
                      {{ $n(item.amount, 'currency', 'pl-PL') }}
                    </template>
                    <template  v-slot:item.posted="{ item }">
                      {{ $n(item.posted, 'currency', 'pl-PL') }}
                    </template>
                    <template  v-slot:item.pay="{ item }">
                      <b>{{ $n(item.amount-item.posted, 'currency', 'pl-PL') }}</b>
                    </template>
                  </v-data-table> 
                </v-card>          
              </v-dialog>

            <v-dialog v-model="dialogPresences" >
              <template v-slot:activator="{ on }">
                 <v-btn @click="loadChildPresence" v-on="on" small color="primary" class="mr-5">Dziennik</v-btn>
              </template>
              <v-card class="pl-1 pr-1">
                <v-data-table
                  :headers="headersPresences"
                  :items="tableChildPresence"
                  class="elevation-0"
                  dense
                  hide-default-footer
                  disable-pagination
                  disable-sort
                  :loading="childPresenceLoadStatus == 1"
                >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Dziennik - {{ childItem.name }} {{ childItem.surname }}</v-toolbar-title>       
                      <v-spacer></v-spacer> 
                    
                      <v-menu
                                      v-model="datePresenceFromMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="presencesDateFrom"
                                          label="Od"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          class="choose_date mt-6 mr-5"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker first-day-of-week="1" no-title v-model="presencesDateFrom" @input="datePresenceFromMenu = false"></v-date-picker>
                      </v-menu>
                      <v-menu
                                      v-model="datePresenceToMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="presencesDateTo"
                                          label="Do"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          class="choose_date mt-6 mr-5"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker first-day-of-week="1" no-title v-model="presencesDateTo" @input="datePresenceToMenu = false"></v-date-picker>
                      </v-menu>


                      <v-btn  @click="dialogPresences = false" outlined class="mb-2 mt-2"  color="primary">
                        <v-icon>mdi-close-thick</v-icon>
                      </v-btn>
                      
                    </v-toolbar>
                  </template>
                  <template  v-slot:item.present="{ item }">
                    <v-simple-checkbox v-if="item.present" v-model="item.present" disabled></v-simple-checkbox>
                  </template>
                  <template  v-slot:item.breakfast="{ item }">
                    <v-simple-checkbox v-if="item.breakfast" v-model="item.breakfast" disabled></v-simple-checkbox>
                  </template>
                  <template  v-slot:item.lunch="{ item }">
                    <v-simple-checkbox v-if="item.lunch" v-model="item.lunch" disabled></v-simple-checkbox>
                  </template>
                  <template  v-slot:item.tea="{ item }">
                    <v-simple-checkbox v-if="item.tea" v-model="item.tea" disabled></v-simple-checkbox>
                  </template>
                  <template  v-slot:item.absent="{ item }">
                    <v-simple-checkbox v-if="!item.present" :value="!item.present" disabled></v-simple-checkbox>
                  </template>
                  <!-- <template v-slot:item.date="{ item }">
                    {{ item.created_at.split(' ')[0] }}
                  </template>
                  <template v-slot:item.hour="{ item }">
                    {{ item.created_at.split(' ')[1] }}
                  </template> -->
                </v-data-table> 
              </v-card>          
            </v-dialog>
        
            <v-dialog v-model="dialogLogs" >
              <template v-slot:activator="{ on }">
                 <v-btn @click="loadChildLog" v-on="on" small color="primary" class="mr-5">Historia operacji</v-btn>
              </template>
              <v-card class="pl-1 pr-1">
                <v-data-table
                  :headers="headersLogs"
                  :items="tableChildLog"
                  class="elevation-0"
                  dense
                  hide-default-footer
                  disable-pagination
                  disable-sort
                  :loading="childLogLoadStatus == 1"
                >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Historia Operacji - {{ childItem.name }} {{ childItem.surname }}</v-toolbar-title>       
                      <v-spacer></v-spacer> 
                    
                      <v-menu
                                      v-model="dateLogFromMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="logsDateFrom"
                                          label="Od"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          class="choose_date mt-6 mr-5"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker first-day-of-week="1" no-title v-model="logsDateFrom" @input="dateLogFromMenu = false"></v-date-picker>
                      </v-menu>
                      <v-menu
                                      v-model="dateLogToMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="logsDateTo"
                                          label="Do"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          class="choose_date mt-6 mr-5"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker first-day-of-week="1" no-title v-model="logsDateTo" @input="dateLogToMenu = false"></v-date-picker>
                      </v-menu>


                      <v-btn  @click="dialogLogs = false" outlined class="mb-2 mt-2"  color="primary">
                        <v-icon>mdi-close-thick</v-icon>
                      </v-btn>
                      
                    </v-toolbar>
                  </template>
                  <template v-slot:item.date="{ item }">
                    {{ item.created_at.split(' ')[0] }}
                  </template>
                  <template v-slot:item.hour="{ item }">
                    {{ item.created_at.split(' ')[1] }}
                  </template>
                </v-data-table> 
              </v-card>          
            </v-dialog>

                <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>  
              <v-toolbar-title><strong>{{ childItem.name }} {{ childItem.surname }}</strong></v-toolbar-title>
            </v-toolbar>

          <v-row>
            <v-col class="pl-5 pr-5">
              <v-card class="elevation-1">
                <v-data-table
                  :headers="headersOwners"
                  :items="tableOwners"
                  sort-by="lp"
                  class="elevation-0"
                  dense
                  hide-default-footer
                  disable-pagination
                  style="background-color: #f4f4f4;"
                >
                  <template v-slot:top>
                    <v-toolbar style="background-color: #f4f4f4;" flat dense>
                      <v-toolbar-title>Opiekunowie</v-toolbar-title>

                      <v-spacer></v-spacer>

                      <v-btn v-if="user.permissions['dictionary'] >= 10" :disabled="tableReferences.length<1 || tableOwners.length<1" @click="copyOwner" x-small class="mb-2 mt-2" color="primary">Skopiuj do powiązanych</v-btn>

                       <v-divider
                        v-if="user.permissions['dictionary'] >= 10"
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      
                     <v-dialog v-if="user.permissions['dictionary'] >= 10" v-model="dialog" max-width="700px">
                        <template v-slot:activator="{ on }">
                          <v-btn @click="addOwner" v-on="on" small class="mb-2 mt-2" fab dark color="primary">
                            <v-icon dark>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <v-card :loading="ownerAddStatus===1 || ownerEditLoadStatus===1 || ownerEditStatus===1">
                          <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                            <v-spacer></v-spacer>
                            <v-checkbox
                                      :disabled="ownerWasDefault"
                                      v-model="editedItem.default"
                                      label="Domyślny"
                                    ></v-checkbox>
                          </v-card-title>

                          <v-card-text>
                            <v-container>
                              
                                <v-row>                   
                                  <v-col cols="12" sm="8" md="8">
                                    <v-text-field v-model="editedItem.name" :error-messages="nameErrors" required @input="$v.editedItem.name.$touch()"  @blur="$v.editedItem.name.$touch()" label="Imię Nazwisko"></v-text-field>                            
                                  </v-col>
                                  <v-col cols="12" sm="4" md="4">
                                    <v-select v-model="editedItem.role" :items="lookups.roles" :error-messages="roleErrors" required @input="$v.editedItem.role.$touch()"  @blur="$v.editedItem.role.$touch()" label="Rola"></v-select>
                                  </v-col>

                                  <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.mobile" :error-messages="mobileErrors" required @input="$v.editedItem.mobile.$touch()"  @blur="$v.editedItem.mobile.$touch()" label="Nr telefonu"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.email" :error-messages="emailErrors" @input="$v.editedItem.email.$touch()"  @blur="$v.editedItem.email.$touch()" label="Adres email"></v-text-field>
                                  </v-col>

                                  <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItem.card" label="Nr karty"></v-text-field>
                                  </v-col>
                                  
                                  <v-col cols="12" sm="4" md="4">
                                    <v-checkbox
                                      v-model="editedItem.permission"
                                      label="Zgoda dostarczona"
                                    ></v-checkbox>                          
                                  </v-col>

                                  <v-col cols="12" sm="4" md="4">
                                    <v-text-field v-if="editedItem.permission" v-model="editedItem.document" label="Nr dokumentu"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="4" md="4">
                                    <v-menu
                                      v-if="editedItem.permission"
                                      v-model="dateDocumentExpiryMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="editedItem.expiry"
                                          label="Data ważności"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          clearable
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker first-day-of-week="1" no-title v-model="editedItem.expiry" @input="dateDocumentExpiryMenu = false"></v-date-picker>
                                    </v-menu>
                                   </v-col>
                                </v-row>
                              
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="gray" text @click="close">Anuluj</v-btn>
                            <v-btn color="primary darken-1" text @click="handleSubmit" >Zapisz</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>
                 
                  <template v-slot:item.permission="{ item }">
                    <v-simple-checkbox style="float:left;" v-model="item.permission" disabled></v-simple-checkbox>
                    <div style="margin-top:2px;" v-if="item.expiry">({{item.expiry}})</div>
                  </template>

                  <template v-slot:item.default="{ item }">
                    <v-simple-checkbox v-model="item.default" disabled></v-simple-checkbox>
                  </template>
                  <template v-slot:item.user_id="{ item }">
                    <v-simple-checkbox :value="item.user_id!=null" disabled></v-simple-checkbox>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip v-if="user.permissions['dictionary'] >= 10" right>
                      <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        size="18"
                        class="mr-2"
                        @click="editOwner(item)"
                      >
                        mdi-pencil
                      </v-icon>
                      </template>
                      <span>Edytuj</span>
                    </v-tooltip>
                    <v-tooltip v-if="item.can_delete && user.permissions['dictionary'] >= 10" right>
                      <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        size="18"
                        class="mr-2"
                        @click="deleteOwner(item)"
                      >
                        mdi-delete
                      </v-icon>
                      </template>
                      <span>Usuń</span>
                    </v-tooltip>

                    <v-tooltip v-if="!item.user_id && user.permissions['dictionary'] >= 10" right>
                      <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        size="18"
                        class="mr-2"
                        @click="toggleMobileAccess(item)"
                      >
                        mdi-cellphone
                      </v-icon>
                      </template>
                      <span>Włącz dostęp mobilny</span>
                    </v-tooltip>

                    <v-tooltip v-if="item.user_id && user.permissions['dictionary'] >= 10" right>
                      <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        size="18"
                        class="mr-2"
                        @click="toggleMobileAccess(item)"
                      >
                        mdi-cellphone-off
                      </v-icon>
                      </template>
                      <span>Wyłącz dostęp mobilny</span>
                    </v-tooltip>

                    <v-tooltip v-if="item.user_id && user.permissions['dictionary'] >= 10" right>
                      <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        size="18"
                        class="mr-2"
                        @click="reseteMobileAccessPassword(item)"
                      >
                        mdi-cellphone-key
                      </v-icon>
                      </template>
                      <span>Resetuj hasło</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
         
        </v-row>
        <v-row>
            
            <v-col class="col-4 pl-5 pr-5">
              <v-card flat class="elevation-1">
                <v-data-table
                  :headers="headersCourse"
                  :items="tableCourse"
                  sort-by="name"
                  class="elevation-0"
                  dense
                  hide-default-footer
                  disable-pagination
                  disable-sort
                  style="background-color: #f4f4f4;"
                >

                  <template v-slot:item.name="{ item }">
                    <span :class="item.status?'':'deleted'">{{item.name}}</span>
                  </template>
                  <template v-slot:item.year_id="{ item }">
                    <span :class="item.status?'':'deleted'">{{item.year_id}}</span>
                  </template>
                  <template v-slot:item.room="{ item }">
                    <span :class="item.status?'':'deleted'">{{item.room}}</span>
                  </template>

                  <template v-slot:top>
                    <v-toolbar flat style="background-color: #f4f4f4;" dense>
                      <v-toolbar-title>Grupa</v-toolbar-title>
                   
                      <v-spacer></v-spacer>

                      <v-select v-if="user.permissions['dictionary'] >= 10"  v-model="selectedCourse" class="choose_course" :items="availableCourses" label="Wybierz grupę" hide-details dense></v-select>
                      <v-divider
                        v-if="user.permissions['dictionary'] >= 10"
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-btn v-if="user.permissions['dictionary'] >= 10" :disabled="!selectedCourse" @click="changeCourse" x-small class="mb-2 mt-2" color="primary">
                        zmień
                      </v-btn>
                      
                    </v-toolbar>
                  </template>
                
                </v-data-table> 
              </v-card>
            </v-col>
          
           <v-col class="pr-5">
            <v-card flat class="elevation-1">
                <v-data-table
                  :headers="headersRates"
                  :items="tableRates"
                  class="elevation-0"
                  dense
                  hide-default-footer
                  disable-pagination
                  disable-sort
                  style="background-color: #f4f4f4;"
                >
                  <template v-slot:item.valid="{ item }">
                    <span :class="(item.status?'':'deleted')+' '+(item.pivot.active?'font-weight-bold':'')">{{item.pivot.created_at}} - {{item.pivot.deleted_at}}</span>
                  </template>
                  <template v-slot:item.name="{ item }">
                    <span :class="(item.status?'':'deleted')+' '+(item.pivot.active?'font-weight-bold':'')">{{item.name}}</span>
                  </template>
                  <template v-slot:item.document="{ item }">
                    <span :class="(item.status?'':'deleted')+' '+(item.pivot.active?'font-weight-bold':'')">{{item.pivot.document}}</span>
                  </template>
                  <template v-slot:item.expiry="{ item }">
                    <span :class="(item.status?'':'deleted')+' '+(item.pivot.active?'font-weight-bold':'')">{{item.pivot.expiry}}</span>
                  </template>

                  <template v-slot:item.monthly="{ item }">
                    <span :class="(item.status?'':'deleted')+' '+(item.pivot.active?'font-weight-bold':'')">{{ $n(item.monthly+item.monthlyMeal+item.monthlyOther, 'number', 'pl-PL') }}</span>
                  </template>
              
                  <template v-slot:item.overtime="{ item }">
                    <span :class="(item.status?'':'deleted')+' '+(item.pivot.active?'font-weight-bold':'')">{{ $n(item.overtime, 'number', 'pl-PL') }}</span>
                  </template>

                  <template v-slot:item.hour="{ item }">
                    <span :class="(item.status?'':'deleted')+' '+(item.pivot.active?'font-weight-bold':'')">{{ $n(item.hour, 'number', 'pl-PL') }}/{{ $n(item.hourNP, 'number', 'pl-PL') }}</span>
                  </template>

                  <template v-slot:item.breakfast="{ item }">
                    <span :class="(item.status?'':'deleted')+' '+(item.pivot.active?'font-weight-bold':'')">{{ $n(item.hasBreakfast?item.breakfast:0 + item.hasLunch?item.lunch:0 + item.hasTea?item.tea:0, 'number', 'pl-PL') }}/{{ $n(item.hasBreakfast?item.breakfastNP:0  + item.hasLunch?item.lunchNP:0 + item.hasTea?item.teaNP:0, 'number', 'pl-PL') }}</span>
                  </template>

                  <template v-slot:top>
                    <v-toolbar flat style="background-color: #f4f4f4;" dense>
                      <v-toolbar-title>Cennik</v-toolbar-title>
                   
                      <v-spacer></v-spacer>

                      <v-dialog v-model="dialogRate" max-width="700px">
                        <template v-if="user.permissions['dictionary'] >= 10" v-slot:activator="{ on }">
                          <v-btn v-on="on" @click="editRate" x-small class="mb-2 mt-2" dark color="primary">
                            edytuj
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">Edycja cennika</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container>
                              
                                <v-row>                   
                                  <v-col cols="12" sm="4" md="4">
                                    <v-select v-model="editedItemRate.rate_id" :items="lookups.rates" :error-messages="rate_idErrors" required @input="$v.editedItemRate.rate_id.$touch()"  @blur="$v.editedItemRate.rate_id.$touch()"  label="Cennik"></v-select>
                                  </v-col>

                                  <v-col cols="12" sm="6" md="4">
                                    <v-text-field v-model="editedItemRate.document" label="Nr dokumentu"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="6" md="4">
                                    <v-menu
                                      v-model="dateMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="editedItemRate.expiry"
                                          label="Data ważności"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          clearable
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker first-day-of-week="1" no-title v-model="editedItemRate.expiry" @input="dateMenu = false"></v-date-picker>
                                    </v-menu>
                                   </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="6" md="6">
                                    <v-menu
                                      v-model="dateValidFromMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          hint="Zostaw puste jeżeli zmiana ma obowiązywać od teraz"
                                          persistent-hint
                                          v-model="editedItemRate.valid_from"
                                          label="Zmiana ważna od"
                                          prepend-icon="mdi-calendar-alert"
                                          readonly
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker 
                                        :min="editedItemRate.changable_from"
                                        first-day-of-week="1" 
                                        no-title 
                                        v-model="editedItemRate.valid_from" 
                                        @input="dateValidFromMenu = false"></v-date-picker>
                                    </v-menu>
                                   </v-col>
                                </v-row>
                              
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeRate">Anuluj</v-btn>
                            <v-btn color="blue darken-1" text @click="handleSubmitRate" >Zapisz</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      
                      
                    </v-toolbar>
                  </template>
                
                </v-data-table> 
              </v-card>
           </v-col>
          </v-row>
          <v-row>
            <v-col class="pl-5 pr-5">
              <v-card flat class="elevation-1">
                <v-data-table
                  :headers="headersReference"
                  :items="tableReferences"
                  class="elevation-0"
                  dense
                  hide-default-footer
                  disable-pagination
                  disable-sort
                  style="background-color: #f4f4f4;"
                >
                  <template v-slot:top>
                    <v-toolbar flat style="background-color: #f4f4f4;" dense>
                      <v-toolbar-title>Powiązane konta - zaległości</v-toolbar-title>
                   
                      <v-spacer></v-spacer>
                      <children-live-search 
                        dense
                        :exclude-child-id="childItem.id"
                        v-if="user.permissions['dictionary'] >= 10"
                        :selectedChild="selectedReference"
                        @childSelected="selectedReference=$event"
                      />
                      <!-- <v-autocomplete
                        v-if="user.permissions['dictionary'] >= 10"
                        v-model="selectedReference"
                        :loading="childrenLookupLoadStatus==1"
                        :items="childrenLookup"
                        :search-input.sync="searchReference"
                        class="mx-4 search"
                        style="max-width: 300px;"
                        flat
                        hide-no-data
                        hide-details
                        label="Wyszukaj dziecko"
                        dense
                      ></v-autocomplete> -->
                      <!-- <v-select v-model="selectedReference" class="search" style="max-width: 200px;" :items="references" label="Wybierz dziecko" hide-details></v-select> -->
                      <v-divider
                        v-if="user.permissions['dictionary'] >= 10"
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-btn v-if="user.permissions['dictionary'] >= 10" :disabled="!selectedReference" @click="addReference" x-small class="mb-2 mt-2"  color="primary">
                        dodaj
                      </v-btn>
                      
                    </v-toolbar>
                  </template>
                  <template v-slot:item.name="{ item }">
                    {{ item.name }} {{ item.surname }}
                  </template>
                   <template  v-slot:item.amount="{ item }">
                      <template v-if="item.last_settlement">{{ $n(item.last_settlement.amount, 'currency', 'pl-PL') }}</template>
                  </template>
                    <template  v-slot:item.posted="{ item }">
                      <template v-if="item.last_settlement">{{ $n(item.last_settlement.posted, 'currency', 'pl-PL') }}</template>
                    </template>
                    <template  v-slot:item.pay="{ item }">
                      <template v-if="item.last_settlement"><b>{{ $n(item.last_settlement.amount-item.last_settlement.posted, 'currency', 'pl-PL') }}</b></template>
                    </template>
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      @click="deleteItemReference(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                   <template v-slot:item.details="{ item }">       
                      <v-btn :to="{name:'slowniki.dziecko',params:{id:item.id,year_id: $route.params.year_id}}" color="primary" x-small>Karta</v-btn>
                  </template>  
                </v-data-table> 
              </v-card>
            </v-col>
          </v-row>
          <v-row> 
            <v-col class="pl-5" col="12" md="auto">
              <v-card flat class="elevation-1 pb-2" style="background-color: #f4f4f4;">
              <v-toolbar flat  dense style="background-color: #f4f4f4;">
                      <v-toolbar-title>Zdjęcie</v-toolbar-title>
                   
                      <v-spacer></v-spacer>
                     
                      <v-dialog v-if="user.permissions['dictionary'] >= 10" v-model="dialogImage" max-width="550px">
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" x-small class="mb-2 mt-2" color="primary">
                            {{childItem.photo?'edytuj':'dodaj'}}
                          </v-btn>
                        </template>
                        <v-card :loading="childEditStatus===1">
                          <v-card-title>
                            <span class="headline">Edycja zdjęcia</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container>
                                <v-row>                   
                                  <v-col cols="12">
                                    <v-image-input
                                      v-model="imageData"
                                      :fullWidth="true"
                                      :fullHeight="true"
                                      :imageMaxScaling="2"
                                      :imageHeight="200"
                                      :imageWidth="200"
                                      :image-quality="0.85"
                                      clearable
                                      image-format="jpeg"
                                    />
                                  </v-col>
                                </v-row>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="gray" text @click="closeImage">Anuluj</v-btn>
                            <v-btn color="primary darken-1" text @click="handleSubmitImage" >Zapisz</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                    </v-toolbar>

              <v-img :src="childItem.photo?childItem.photo:'/empty.png'"  class="ml-2 mr-2" width="200" height="200" ></v-img>
              </v-card>
            </v-col>

            <v-col  col="12" md="auto">
              <v-card    flat class="elevation-1" style="background-color: #f4f4f4;">
              <v-toolbar flat dense style="background-color: #f4f4f4;">
                  <v-toolbar-title>Kod QR</v-toolbar-title>
                  <v-spacer></v-spacer>

                    <v-menu
                      v-model="qrcodeMenu"
                      
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                            size="28"
                            class="ml-5"
                          >
                            mdi-printer
                          </v-icon>
                      </template>

                      <v-card width="250">
                              <v-select
                                v-model="qrcodeQty"
                                class="ml-5 mr-5"
                                :items="[
                                          { text: '1 karta', value: 1 },
                                          { text: '2 karty', value: 2 },
                                          { text: '3 karty', value: 3 },
                                          { text: '4 karty', value: 4 },
                                          { text: '5 kart', value: 5 },
                                          { text: '6 kart', value: 6 },
                                          { text: '7 kart', value: 7 },
                                          { text: '8 kart', value: 8 },
                                        ]"
                                single-line
                              ></v-select>
                        <v-card-actions>
                          <v-spacer></v-spacer>

                          <v-btn text @click="qrcodeMenu = false">Anuluj</v-btn>
                          <v-btn color="primary" text @click="printFile">Drukuj</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>

              </v-toolbar>
               
              <!-- <v-img class="ml-2 mr-2" :src="generateQRCode" /> -->
               <qrcode @qr-change="qrcode=$event" :value="JSON.stringify({ logus: childItem.code })"  class="ml-2 mr-2" tag="img" :options="{ width: 200, margin:0, quality:1 }"></qrcode>
              </v-card>
            </v-col>
            <v-col class="pr-5" col="4" >
              <v-card flat height="100%" class="elevation-1 pb-2" style="background-color: #f4f4f4;">
              <v-toolbar flat dense style="background-color: #f4f4f4;">
                      <v-checkbox class="mt-6" v-model="childItem.diet" />
                      <v-toolbar-title>Dieta</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn v-if="user.permissions['dictionary'] >= 10" 
                        :disabled="(((childItem.diet_note===null) ? '': childItem.diet_note) === ((childItem.noteDietOrig===null) ? '': childItem.noteDietOrig)) &&  childItem.diet===childItem.dietOrig"  
                        @click="saveDietNote" x-small class="mb-2 mt-2"  color="primary">
                        zapisz
                      </v-btn>
                    </v-toolbar>

              <v-textarea
                :readonly="user.permissions['dictionary'] < 10"
                outlined
                height="200px"
                name="input-7-4"
                class="ml-2 mr-2"
                hide-details
                v-model="childItem.diet_note"
                :disabled="!childItem.diet"
              ></v-textarea>
              </v-card>
            </v-col>
            <v-col class="pr-5" col="12" >
              <v-card flat height="100%" class="elevation-1 pb-2" style="background-color: #f4f4f4;">
              <v-toolbar flat dense style="background-color: #f4f4f4;">
                      <v-toolbar-title>Dodatkowe informacje</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn v-if="user.permissions['dictionary'] >= 10" :disabled="((childItem.note===null) ? '': childItem.note) === ((childItem.noteOrig===null) ? '': childItem.noteOrig)"  @click="saveNote" x-small class="mb-2 mt-2"  color="primary">
                        zapisz
                      </v-btn>
                    </v-toolbar>

              <v-textarea
                :readonly="user.permissions['dictionary'] < 10"
                outlined
                height="200px"
                name="input-7-4"
                class="ml-2 mr-2"
                hide-details
                v-model="childItem.note"
              ></v-textarea>
              </v-card>
            </v-col>
          </v-row>
          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
</template>

<script>
  import Vue from 'vue';
  import i18n from "../main";
  import XLSX from "xlsx"
  import qrcode from '../components/QRCode'; 
  import VImageInput from 'vuetify-image-input';
  import confirm from '../components/Confirm'
  import ChildrenLiveSearch from '../components/ChildrenLiveSearch'
  import required from 'vuelidate/lib/validators/required'
  import minLength from 'vuelidate/lib/validators/minLength'
  import maxLength from 'vuelidate/lib/validators/maxLength'
  import numeric from "vuelidate/lib/validators/numeric";
  import email from "vuelidate/lib/validators/email";

  import {jsPDF} from 'jspdf'
  import logusLogo from '../plugins/jspdf_resources'

  export default {
    components:{
      VImageInput,
      confirm,
      qrcode,
      ChildrenLiveSearch
    },
    data: () => ({
      qrcode:'',
      qrcodeMenu:false,
      qrcodeQty:2,
      componentKey:0,
      dialog: false,
      dialogRate: false,
      dialogImage: false,
      imageData:null,
      dialogSettlements: false,
      dialogLogs: false,
      dialogPresences: false,
      selectedReference:null,
      //searchReference: null,
      itemEditing:false,
      ownerWasDefault:false,
      searchChild:'',
      selectedCourse:'',
      dateMenu:false,
      dateDocumentExpiryMenu:false,
      dateValidFromMenu:false,
      dateLogFromMenu:false,
      dateLogToMenu:false,
      datePresenceFromMenu:false,
      datePresenceToMenu:false,
      dateSettlementsFromMenu:false,
      dateSettlementsToMenu:false,
      headersOwners: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false},
        { text: 'Imię Nazwisko', value: 'name' },
        { text: 'Rola', value: 'role' },
        { text: 'Nr telefonu', value: 'mobile' },
        { text: 'Adres email', value: 'email' },
        //{ text: 'Nr karty', value: 'card' },
        { text: 'Zgoda', value: 'permission' },
        { text: 'Domyślny', value: 'default' },
        { text: "Dostęp mobilny", value: "user_id", sortable: false },
        { text: "Akcje", value: "actions", sortable: false },
      ],
      headersCourse: [
        { text: 'Nazwa', value: 'name' },
        { text: 'Rok szkolny', value: 'year' },
        { text: 'Sala', value: 'room' },
      ],
      headersRates: [
        { text: 'Obowiązuje', value: 'valid' },
        { text: 'Nazwa', value: 'name' },
        { text: 'Stałe', value: 'monthly' },
        { text: 'Nadgodziny', value: 'overtime' },
        { text: 'Pobyt', value: 'hour' },
        { text: 'Żywienie', value: 'breakfast'},
        { text: 'Nr dokumentu', value: 'document'},
        { text: 'Data ważności', value: 'expiry'},
        
      ],
       headersLogs: [
        { text: 'Data', value: 'date' },
        { text: 'Godzina', value: 'hour' },
        { text: 'Operacja', value: 'action'},
        { text: 'Parametr', value: 'param'},
        { text: 'Przed', value: 'before'},
        { text: 'Po', value: 'after'},
        { text: 'Dokonał zmiany', value: 'user'},
      ],
       headersPresences: [
        { text: 'Data', value: 'day' },
        { text: 'Grupa', value: 'course' },
        { text: 'Obecny', value: 'present'},
        { text: 'Godzina wejścia', value: 'entry'  },
        { text: 'Śniadanie', value: 'breakfast' },
        { text: 'Obiad', value: 'lunch' },
        { text: 'Podwieczorek', value: 'tea'},
        { text: 'Godzina wyjścia', value: 'leave'},
        { text: 'Nieobecny', value: 'absent'},
        { text: 'Uwagi', value: 'note' },
      ],
      headersSettlements: [
        { text: 'Rok', value: 'year' },
        { text: 'Miesiąc', value: 'month' },
        { text: 'Cennik', value: 'rates' },
        { text: 'Kwota rozliczenia', value: 'amount'},
        { text: 'Zapłacono', value: 'posted'},
        { text: 'Do zapłaty', value: 'pay'},
        { text: 'Nr dokumentu', value: 'document_numbers'},
      ],
      headersReference: [
        { text: '',align: 'start',value: 'lp',},
        { text: 'Dziecko', value: 'name' },
        { text: 'Kwota rozliczenia', value: 'amount' },
        { text: 'Zapłacono', value: 'posted'},
        { text: 'Do zapłaty', value: 'pay'},
        { text: 'Nr dokumentu', value: 'last_settlement.documents'},
        { text: 'Akcje', value: 'actions', sortable: false },
        { text: '', value: 'details', sortable: false },
      ],
    }),
    validations: {
      editedItem:{
        name: {
          required,
        },
        mobile: {
           required,
            numeric,
            minLength:minLength(9),
            maxLength:maxLength(9)
        },
        role:{
          required,
        },
        email:{
          email,
        },
      },
      editedItemRate:{
        rate_id: {
          required,
        },
      },
      
    },
    watch: {
      $route(to, from) {
        this.loadChild();
      },
      dialog (val) {
        this.$v.editedItem.$reset()
        val || this.close()
       
      },
      dialogRate (val) {
        this.$v.editedItemRate.$reset()
        val || this.closeRate()
       
      },
      dialogImage (val) {
        if(val){
          this.imageData = this.childItem.photo;
        }
      },
      ownerEditStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
        }
      },
      ownerAddStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
        }
      },
      ownerDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      },
      childRateEditStatus(val){
        if(val===2){
          this.closeRate();
          this.componentKey += 1;
        }
      },
      childEditStatus(val){
        if(val===2){
          this.closeImage();
        }
      },
      // searchReference (val) {
      //   val && val !== this.selectedReference && val.length>2 && this.querySelectionsReference(val)
      // },
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      
      logsDateFrom: {
        get () {
          return this.$store.getters.getChildLogOptions.fromDate;
        },
        set (value) {
          var currentOptions = {...this.$store.getters.getChildLogOptions};
          currentOptions.fromDate = value;
          this.$store.dispatch( 'setChildLogOptions', {options:currentOptions} )
        }
      },

      logsDateTo: {
        get () {
          return this.$store.getters.getChildLogOptions.toDate;
        },
        set (value) {
          var currentOptions = {...this.$store.getters.getChildLogOptions};
          currentOptions.toDate = value;
          this.$store.dispatch( 'setChildLogOptions', {options:currentOptions} )
        }
      },

      presencesDateFrom: {
        get () {
          return this.$store.getters.getChildPresenceOptions.fromDate;
        },
        set (value) {
          var currentOptions = {...this.$store.getters.getChildPresenceOptions};
          currentOptions.fromDate = value;
          this.$store.dispatch( 'setChildPresenceOptions', {options:currentOptions} )
        }
      },

      presencesDateTo: {
        get () {
          return this.$store.getters.getChildPresenceOptions.toDate;
        },
        set (value) {
          var currentOptions = {...this.$store.getters.getChildPresenceOptions};
          currentOptions.toDate = value;
          this.$store.dispatch( 'setChildPresenceOptions', {options:currentOptions} )
        }
      },

      settlementsDateFrom: {
        get () {
          return this.$store.getters.getChildSettlementsOptions.fromDate;
        },
        set (value) {
          var currentOptions = {...this.$store.getters.getChildSettlementsOptions};
          currentOptions.fromDate = value;
          this.$store.dispatch( 'setChildSettlementsOptions', {options:currentOptions} )
        }
      },

      settlementsDateTo: {
        get () {
          return this.$store.getters.getChildSettlementsOptions.toDate;
        },
        set (value) {
          var currentOptions = {...this.$store.getters.getChildSettlementsOptions};
          currentOptions.toDate = value;
          this.$store.dispatch( 'setChildSettlementsOptions', {options:currentOptions} )
        }
      },

      childItem(){
        return this.$store.getters.getChild;
      },
      childLogItem(){
        return this.$store.getters.getChildLog;
      },
      childPresenceItem(){
        return this.$store.getters.getChildPresence;
      },
      childSettlementsItem(){
        return this.$store.getters.getChildSettlements;
      },
      editedItem(){
        return this.$store.getters.getOwnerEdit;
      },
       editedItemRate(){
        return this.$store.getters.getChildRateEdit;
      },
      tableOwners(){
        return this.childItem.owners;
      },
      tableCourse(){
        return this.childItem.courses;
      },
      availableCourses(){
        return this.$store.getters.getLookups.courses.filter(u => !_.find(this.tableCourse,{'id':u.value}));
      },
      tableRates(){
        return this.childItem.rates;
      },
      tableReferences(){
        return this.childItem.references;
      },
      tableChildLog(){
        return this.childLogItem.logs;
      },
      tableChildSettlements(){
        return this.childSettlementsItem.settlements;
      },
      tableChildPresence(){
        return this.childPresenceItem.presences;
      },
      childLoadStatus(){
        return this.$store.getters.getChildLoadStatus;
      },
      childLogLoadStatus(){
        return this.$store.getters.getChildLogLoadStatus;
      },
      childPresenceLoadStatus(){
        return this.$store.getters.getChildPresenceLoadStatus;
      },
      childSettlementsLoadStatus(){
        return this.$store.getters.getChildSettlementsLoadStatus;
      },
      ownerEditLoadStatus(){
        return this.$store.getters.getOwnerEditLoadStatus
      },
      childEditStatus(){
        return this.$store.getters.getChildEditStatus();
      },
      ownerEditStatus(){
        return this.$store.getters.getOwnerEditStatus();
      },
      ownerEditText(){
        return this.$store.getters.getOwnerEditText
      },
      childRateEditLoadStatus(){
        return this.$store.getters.getChildRateEditLoadStatus
      },
      childRateEditStatus(){
        return this.$store.getters.getChildRateEditStatus();
      },
      childRateEditText(){
        return this.$store.getters.getChildRateEditText
      },
      ownerAddStatus(){
        return this.$store.getters.getOwnerAddStatus();
      },
      ownerAddText(){
        return this.$store.getters.getOwnerAddText;
      },
      ownerDeleteStatus(){
        return this.$store.getters.getOwnerDeleteStatus();
      },
      // childrenLookupLoadStatus(){
      //   return this.$store.getters.getChildrenLookupLoadStatus;
      // },
      // childrenLookup(){
      //   return this.$store.getters.getChildrenLookup;
      // },
      formTitle () {
        return !this.itemEditing ? 'Nowy opiekun' : 'Edycja opiekuna'
      },
      nameErrors () {
        const errors = []
        if (!this.$v.editedItem.name.$dirty) return errors
        !this.$v.editedItem.name.required && errors.push('Nazwisko i imię jest wymagana')
        return errors
      },
      roleErrors () {
        const errors = []
        if (!this.$v.editedItem.role.$dirty) return errors
        !this.$v.editedItem.role.required && errors.push('Rola jest wymagana')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.editedItem.email.$dirty) return errors
        !this.$v.editedItem.email.email && errors.push('E-Mail jest niepoprawny')
        return errors
      },
       mobileErrors () {
        const errors = []
        if (this.itemEditingPassword || !this.$v.editedItem.mobile.$dirty) return errors
        !this.$v.editedItem.mobile.required && errors.push('Telefon jest wymagany')
        !this.$v.editedItem.mobile.numeric && errors.push('Telefon może zawierać tylko cyfry')
        !this.$v.editedItem.mobile.minLength && errors.push('Telefon musi mieć 9 cyfr')
        !this.$v.editedItem.mobile.maxLength && errors.push('Telefon musi mieć 9 cyfr')
        return errors
      },
      rate_idErrors () {
        const errors = []
        if (!this.$v.editedItemRate.rate_id.$dirty) return errors
        !this.$v.editedItemRate.rate_id.required && errors.push('Cennik jest wymagany')
        return errors
      },
      // generateQRCode(){
      //   var QRCodeStyling = require('qr-code-styling')

      //   const qr = new QRCodeStyling({
      //     width: 200,
      //     height: 200,
      //     data: "DATA",//JSON.stringify({ logus: this.childItem.code }),
      //     qrOptions: {typeNumber: 0, errorCorrectionLevel: 'Q'},
      //     imageOptions: {imageSize: 0.4, margin:3},
      //     dotsOptions: {type: 'rounded'},
      //     image: "assets/images/icon.png",
      //     //cornersSquareOptions: {type: 'square'},
      //     //cornersDotOptions: {type: 'square'},
      //   });

      //   return qr._canvas.getCanvas().toDataURL('image/png', 100);
      // }   
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadChild();
        //this.loadChildren();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadChild();
          
          //this.loadChildren();
        }, 2000)
      }
    },
    methods: {
      loadChild(){
        this.$store.dispatch( 'loadChild', {slug:  this.$route.params.id, year_id: this.$route.params.year_id} );
        this.$store.dispatch( 'loadCourseLookup', {year_id:this.$route.params.year_id} );
        this.$store.dispatch( 'loadRateLookup', {year_id:this.$route.params.year_id} );
      },
      loadChildLog(){
        var currentOptions = {...this.$store.getters.getChildLogOptions};
        var dateFrom = new Date(); 
        var dateTo = new Date(); 
        var dateFrom = new Date(dateFrom.setMonth(dateTo.getMonth()-1));
        currentOptions.fromDate = dateFrom.toISOString().substr(0,10);
        currentOptions.toDate = dateTo.toISOString().substr(0,10);
        this.$store.dispatch( 'setChildLogOptions', {options:currentOptions} )
        //this.$store.dispatch( 'loadChildLog' );
      },
      loadChildPresence(){
        var currentOptions = {...this.$store.getters.getChildPresenceOptions};
        var dateFrom = new Date(); 
        var dateTo = new Date(); 
        var dateFrom = new Date(dateFrom.setMonth(dateTo.getMonth()-1));
        currentOptions.fromDate = dateFrom.toISOString().substr(0,10);
        currentOptions.toDate = dateTo.toISOString().substr(0,10);
        this.$store.dispatch( 'setChildPresenceOptions', {options:currentOptions} )
        //this.$store.dispatch( 'loadChildPresence' );
      },
       loadChildSettlements(){
        var currentOptions = {...this.$store.getters.getChildSettlementsOptions};
        var dateFrom = new Date(); 
        var dateTo = new Date(); 
        var dateFrom = new Date(dateFrom.setFullYear(dateTo.getFullYear()-1));
        currentOptions.fromDate = dateFrom.toISOString().substr(0,7);
        currentOptions.toDate = dateTo.toISOString().substr(0,7);
        this.$store.dispatch( 'setChildSettlementsOptions', {options:currentOptions} )
        //this.$store.dispatch( 'loadChildSettlements' );
      },
      editOwner (item) {
        this.ownerWasDefault = item.default
        this.itemEditing = true
        this.$store.dispatch( 'loadOwnerEdit', {slug: item.id});  
        this.dialog = true
      },
      copyOwner () {
        this.$store.dispatch( 'copyOwner', {slug: this.childItem.id});  
      },
      addOwner () {
        this.editedItem.default = this.tableOwners.length==0
        this.ownerWasDefault = this.editedItem.default
        this.itemEditing = false
        this.dialog = true
      },
      deleteOwner (item) {
          this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać opiekuna na stałe?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'forceDeleteOwner', {slug:  item.id});
            }
        })
      },
      changeCourse(){
        this.$store.dispatch( 'editChildCourse',{slug:this.childItem.id,course_id:this.selectedCourse});
      },
      close () {
        this.dialog = false
        this.$v.editedItem.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadOwnerEditDefault'); 
          this.$store.dispatch( 'loadOwnerAddDefault');
          this.itemEditing = false
        }, 300)
      },
      editRate(){
        //tylko jak jest edycja
        if(this.tableRates.length>0){
          this.$store.dispatch( 'loadChildRateEdit', {slug: this.childItem.id});  
        }
      },
      closeRate () {
        this.dialogRate = false
        this.$v.editedItemRate.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadChildRateEditDefault'); 
        }, 300)
      },
      closeImage () {
        this.dialogImage = false
        //this.imageData = null
        //this.$v.editedItemRate.$reset()
        // setTimeout(() => {
        //   this.$store.dispatch( 'loadChildRateEditDefault'); 
        // }, 300)
      },
      // querySelectionsReference (v) {
      //   this.$store.dispatch( 'searchChildrenLookup',{q:v,slug:this.childItem.id}); 
      // },
      addReference(){
        this.$store.dispatch( 'childrenAddReference',{slug:this.childItem.id,child_id:this.selectedReference}); 
        this.selectedReference = null;
      },
      deleteItemReference(item){
         this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać powiązane dziecko?', { color: 'error' }).then((confirm) => {
            if(confirm){
              this.$store.dispatch( 'childrenDeleteReference',{slug:this.childItem.id,child_id:item.id}); 
            }
        })
      },
      saveNote(){
        this.$store.dispatch( 'childrenAddNote',{slug:this.childItem.id,note:this.childItem.note}); 
      },
      saveDietNote(){
        this.$store.dispatch( 'childrenAddDietNote',{slug:this.childItem.id,diet:this.childItem.diet,diet_note:this.childItem.diet_note}); 
      },
      monthName(val){
        return Vue._.find(this.lookups.months, {'value':val}).text;
      },
      downloadSettlementsFile(){
        //przygotowanie danych
        var items = []
        this.tableChildSettlements.forEach(item => {
          items.push({year:item.year, month:this.monthName(item.month), rates:item.rates, 
          amount:item.amount, posted:item.posted, pay:item.amount-item.posted, documents:item.document_numbers})
        });

        var wb = XLSX.utils.book_new()
        var ws_name = "Zestawienie";
        var ws = XLSX.utils.aoa_to_sheet([["Rok","Miesiąc","Cennik","Kwota rozliczenia","Zapłacono","Do zapłaty","Dokumenty"]]);
        XLSX.utils.sheet_add_json(ws,items,{header:["year","month","rates","amount","posted","pay","documents"], skipHeader:true, origin:1})
        
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
      
        var rightNow = new Date();
        rightNow.setMinutes(rightNow.getMinutes() - rightNow.getTimezoneOffset());
        var filename = 'Zestawienie_' + rightNow.toISOString().replace(/-/g,'').replace(/:/g,'').replace('T','_').slice(0,15) +'.xlsx';
        XLSX.writeFile(wb, filename, {})

      },
      toggleMobileAccess(item){
        if(item.user_id){//wylaczanie dostepu
          if(this.childItem.references.length>0){
            this.$refs.confirm.open('Potwierdź usunięcie', 'Jeżeli w kontach powiązanych ten opiekun ma dostęp mobilny, to również zostanie on wyłączony. Czy nadal chcesz usunać dostęp?', { color: 'error' }).then((confirm) => {
              if(confirm){
                  this.$store.dispatch( 'deleteUserFromOwner', {slug: item.id});
              }
            })
          }else this.$store.dispatch( 'deleteUserFromOwner', {slug: item.id});

        }else if(item.possible_user){//wlaczanie, jest juz taki user, potwierdz, ze z tym ma sie laczyc
          this.$refs.confirm.open('Potwierdź', 'Istnieje już użytkownik o takim numerze telefonu, to: ' + item.possible_user.name + ' ' + item.possible_user.surname + '. Czy chcesz wybrać tego użytkownika?', { color: 'error' }).then((confirm) => {
              if(confirm){
                  this.$store.dispatch( 'addUserToOwner', {slug: item.id, user_id: item.possible_user.id,password:null });
              }
          })
        }else{//wlaczanie, dodawanie nowego uzytkownika
          var pass = this.randString();
          if(process.env.NODE_ENV=='development')console.log(pass);
          this.$store.dispatch( 'addUserToOwner', {slug: item.id, user_id: null,password:pass });
        }
      },
      reseteMobileAccessPassword(item){
          var pass = this.randString();
          if(process.env.NODE_ENV=='development')console.log(pass);
          this.$store.dispatch( 'resetUserPassword', {slug: item.id,password:pass  });
      },
      randString(){
        var possible = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
        var possibleNumber = '23456789';
        var text = '';
        for(var i=0; i < 7; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        text += possibleNumber.charAt(Math.floor(Math.random() * possibleNumber.length));
        return text;
      },
      handleSubmit () {
        this.$v.editedItem.$touch()
        if (this.$v.editedItem.$invalid) {

        } else {
         
            if (this.itemEditing) {
              //edycja
              this.$store.dispatch( 'editOwner', {
                slug: this.editedItem.id,
                child_id: this.childItem.id,
                name:  this.editedItem.name,
                role: this.editedItem.role,
                mobile: this.editedItem.mobile,
                email: this.editedItem.email,
                card: this.editedItem.card,
                permission: this.editedItem.permission,
                document: this.editedItem.document,
                expiry: this.editedItem.expiry,
                default:this.editedItem.default
              });
            } else {//new item
              this.$store.dispatch( 'addOwner', {
                child_id: this.childItem.id,
                name:  this.editedItem.name,
                role: this.editedItem.role,
                mobile: this.editedItem.mobile,
                email: this.editedItem.email,
                card: this.editedItem.card,
                permission: this.editedItem.permission,
                document: this.editedItem.document,
                expiry: this.editedItem.expiry,
                default:this.editedItem.default
              });

            }
        }
      },
      handleSubmitRate () {
        this.$v.editedItemRate.$touch()
        if (this.$v.editedItemRate.$invalid) {

        } else {
              this.$store.dispatch( 'editChildRate', {
                slug: this.childItem.id,
                rate_id: this.editedItemRate.rate_id,
                document:  this.editedItemRate.document,
                expiry: this.editedItemRate.expiry,
                valid_from: this.editedItemRate.valid_from
              });
        }
      },      
      handleSubmitImage () {
        //this.$v.editedItemRate.$touch()
        // if (this.$v.editedItemRate.$invalid) {
        // } else {
              this.$store.dispatch( 'childrenAddImage', {
                slug: this.childItem.id,
                input_img: this.imageData,
              });
        // }
      }, 
      generatePDF(){
        var doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
        })
        var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

        var xStart = 10;
        var yStart = 10;
        for (let i = 1; i <= this.qrcodeQty; i++) {
          doc.roundedRect(xStart,yStart,54,86,2,2);
          doc.addImage(logusLogo, 'PNG', xStart + 16, yStart + 5, 22.5, 20);
          doc.addImage(this.qrcode, 'PNG', xStart + 7, yStart +36, 40, 40);
          doc.setFont("Roboto-Regular", "normal");
          doc.setFontSize(11);
          doc.text(this.childItem.name+' '+this.childItem.surname, xStart + 26, yStart + 31, {align:'center'});
          doc.setFontSize(12);
          if(this.tableCourse && this.tableCourse.length>0)
            doc.text(this.tableCourse[0].name, xStart + 26, yStart + 82, {align:'center'});
          xStart = xStart + 54 + 5
          if(i==4){
            xStart = 10;
            yStart+= 86 + 5;
          }
        }

        return doc;
      },
      printFile(){
        this.qrcodeMenu = false;
        var doc = this.generatePDF();
        doc.autoPrint();
        doc.output('dataurlnewwindow');
       
      }, 
      
    },
  }
</script>


<style scoped>
.search{
      max-width: 250px;
}
.choose_year{
      max-width: 150px;
}

.choose_course{
      max-width: 150px;
}
.choose_date{
      max-width: 150px;
}

.grey_card{
    background-color: #f4f4f4;
}
</style>